//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageBtns from '@/components/common_pageBtns.vue'
export default {
  components: { PageBtns },
  props: ["list"],
  data () {
    return {
      btnConfig: {
        list: [
          {text:'返回', type:'primary',action: () => this.$router.go(-1)}
        ],
      },
    }
  },
  methods: {
    onClickItem (item,index) {
      if (item.link) {
        if (item.link.indexOf('http') == -1) {
          this.$router.push(item.link)
        } else {
          window.location = item.link
          this.$msg.loading()
        }
      }
      if (item.action) this.$emit(item.action, index,item)
    },
  }
};
